import { LanguageKey } from "../_utils";

export interface Company {
  id?: number;
  name: string;
  alias: string;
  logo: string;
  domain: string;
  language: LanguageKey;
  establishmentDate: string;
  slackConnectedFlg: boolean;
  jiraConnectedFlg: boolean;
  gitConnected: boolean;
  taxId?: number;
}

export interface PayLoadPatchCompany {
  type: string;
  value: boolean | string;
}

export class ConnectSlack {
  slackConnectedFlg?: boolean;
  code?: string;
}

export class CompanyStorage {
  total: number;
  used: number;
}
